module.exports = "https://health.dajiuxing.com.cn/img/assets/serviceImg/jdwx1.png"


//////////////////
// WEBPACK FOOTER
// ./build/cdn-img-stub.js?path=assets%2FserviceImg%2Fjdwx1.png
// module id = Rbhx
// module chunks = 93